import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from 'semantic-ui-react';
import MoreVert from '@material-ui/icons/MoreVert';
import Server from '../../functions/server'
import $ from "jquery";
import Dialogbox from './dialogbox';
import Loading from '../loading';
import { Link } from 'react-router-dom';
import Release from '../../functions/release';

class Sales extends React.Component {

  state = {
    data: [],
    open: false
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  startingMonth() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    let fromMonth = yyyy+'-'+mm+'-01';
    return fromMonth;
  }

  startingYear() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if (mm < 3) { yyyy = yyyy - 1; }
    if(mm < 10){ mm = '0' + mm; }
    let fromYear = yyyy+'-04-01';
    return fromYear;
  }

  viewBranch(type) {
    let context = this;
    let today = this.getToday();
    let startingMonth = this.startingMonth();
    let staringYear = this.startingYear();
    context.setState({ load: true, message: 'Getting values' })
    $.ajax({
      type: 'POST',
      data: { 'today': today, 'startingMonth': startingMonth, 'staringYear': staringYear, 'type': type },
      url: Server() + 'dashboard/purchasebranch.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true, load: false })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let monthly_purchase, yearly_purchase;
    let data = this.props.data.map((x) => {
      monthly_purchase = x.month_purchase;
      yearly_purchase = x.year_purchase;
    });
    if (monthly_purchase == null) {
      monthly_purchase = 0;
    }
    if (yearly_purchase == null) {
      yearly_purchase = 0;
    }
    yearly_purchase = Number(yearly_purchase);
    yearly_purchase = yearly_purchase.toFixed(2);
    monthly_purchase = Number(monthly_purchase);
    monthly_purchase = monthly_purchase.toFixed(2);
    let fontSize = 25;
    if (monthly_purchase >= 999999.99 || yearly_purchase >= 999999.99) {
      fontSize = 20;
    }
    if (monthly_purchase >= 99999999.99 || yearly_purchase >= 99999999.99) {
      fontSize = 19;
    }
    if (monthly_purchase >= 99999999.99 || yearly_purchase >= 99999999.99) {
      fontSize = 18;
    }
    if (monthly_purchase >= 999999999.99 || yearly_purchase >= 999999999.99) {
      fontSize = 17;
    }
    if (monthly_purchase >= 9999999999.99 || yearly_purchase >= 9999999999.99) {
      fontSize = 16;
    }
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Card style={{backgroundColor: '#abb119'}}>
              <div style={{display: 'flex', padding: '2%'}}>
                <div style={{fontSize: 17, color: 'white'}}><b>Purchase Detail</b></div>
                <div style={{paddingLeft: '63%', color: 'white', fontSize: 17, display: 'none'}}><MoreVert style={{cursor: 'pointer'}} /></div>
              </div>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Link to={"/"+Release()+"/purchase-details"}>
                    <CardContent>
                        <div style={{color: 'white'}}>This Month<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: 15}}>{'₹'+monthly_purchase}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'month')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Link to={"/"+Release()+"/purchase-details"}>
                    <CardContent>
                        <div style={{color: 'white'}}>This Financial Year<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: 15}}>{'₹'+yearly_purchase}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'year')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
              </Grid>
            </Card>
          </Grid.Column>
        </Grid>
        { this.state.open ?
          (
            <div>
              <Dialogbox col2="Branch" col3="Amount" type="amount" data={this.state.data} open={this.state.open} handleClose={ () => { this.setState({ open: false }) }} title='Purchase Report' />
            </div>
          ) :
          (
            <div></div>
          )
        }
      </div>
    );
  }
}

export default Sales;
